import { devtools } from "zustand/middleware";
import { create } from "zustand/react";
import { Order, OrderTabs } from "@/types";

type OpenParams = {
  orderId?: number | null;
  order?: Order | null;
  tab?: OrderTabs;
};

type OrdersDrawerState = {
  isOpen: boolean;
  orderId: number | null;
  order: Order | null;
  selectedTab: OrderTabs;
  open: (params: OpenParams) => void;
  close: () => void;
  setSelectedTab: (tab: OrderTabs) => void;
};

export const useOrdersDrawerStore = create<OrdersDrawerState>()(
  devtools((set) => ({
    isOpen: false,
    orderId: null,
    order: null,
    selectedTab: "details",
    open: ({ orderId = null, order = null, tab = "details" }) =>
      set({ isOpen: true, orderId, order, selectedTab: tab }),
    close: () => set({ isOpen: false, orderId: null, order: null, selectedTab: "details" }),
    setSelectedTab: (selectedTab) => set({ selectedTab }),
  }))
);
